const mEditionAssetSendingOfDeliverablesModalCreate = {
  mEditionAssetSendingOfDeliverablesModalCreate: {
    alerts: {
      createContenidoEntregable: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'El entregable fue creado exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'CREAR',

    inputs: {
      asunto: {
        label: 'Asunto',
        message: '* De 5 a 255 caracteres'
      },

      mensaje: {
        label: 'Mensaje'
      }
    },

    title: 'Crear Entregable',

    validation: {
      asunto: {
        maxLength: 'La longitud máxima permitida es de 255 caracteres.',
        minLength: 'La longitud mínima permitida es de 5 caracteres.',
        required: 'Asunto de entregable es requerido. De 5 a 255 caracteres.'
      },

      mensaje: {
        required: 'Mensaje de entregable es requerido.'
      }
    }
  }
}

export default mEditionAssetSendingOfDeliverablesModalCreate
